<template>
  <div id="app" v-loading.fullscreen.lock="fullPageLoading">
    <el-container style="height: 100vh;">
      <el-aside v-if="isUserSignin" :width="menuVerticalWidth">
        <MenuVertical :collapse="isMenuCollapse" />
      </el-aside>
      <el-container direction="vertical">
        <!-- <el-header v-if="isUserSignin" height="50px" style="line-height: 50px;">
          <MenuHorizontal @menuToggle="onMenuToggle" />
        </el-header> -->
        <div v-if="isUserSignin" class="header-container">
          <MenuHorizontal @menuToggle="onMenuToggle" @menuAbout="onAbout" />
        </div>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>

    <el-dialog
      :title="$t('common.about.modal.title')"
      :visible.sync="aboutModal"
      :close-on-click-modal="false"
      class="about"
      width="25%"
      v-draggable
    >
      <el-row type="flex" justify="space-between" align="middle">
        <el-col :span="24" class="logo-container">
          <span class="name">{{ serverVersion.applname }}</span>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between" align="middle">
        <el-col :span="24" class="description">
          {{ $t("common.about.modal.descritpionAbon") }}<br />
          {{ $t("common.about.modal.descritpionComm") }}
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between" align="middle">
        <el-col :span="24" class="version">
          {{ $t("common.about.modal.clientVersion", { version: webVersion }) }}
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between" align="middle">
        <el-col :span="24" class="version">
          {{
            $t("common.about.modal.serverVersion", {
              version: serverVersion.version
            })
          }}
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between" align="middle">
        <el-col :span="24" class="version">
          {{
            $t("common.about.modal.apiVersion", { version: apiVersion.version })
          }}
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between" align="middle">
        <el-col :span="24" class="copyright">
          &copy; 2019-2024
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="24" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="aboutModal = false"
              >{{ $t("common.buttons.confirmOk") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <GridContextMenu></GridContextMenu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { clearSession } from "@/helpers/store";
import MenuHorizontal from "@/components/MenuHorizontal";
import MenuVertical from "@/components/MenuVertical";
import GridContextMenu from "@/components/GridContextMenu";
import { version } from "@/mixins/version";

export default {
  name: "app",
  mixins: [version],
  components: {
    MenuHorizontal,
    MenuVertical,
    GridContextMenu
  },
  async created() {
    const savedConnection = this.$localStorage.get("wb-connection");
    if (savedConnection) {
      const connect = JSON.parse(savedConnection);
      const language = connect.language || "";

      if (language) {
        this.$i18n.locale = language === "uk" ? "ua" : language;
        const locale = language === "ua" ? "uk" : language;
        this.$moment.locale(locale);
      }
    }

    // if (this.isUserSignin) await this.getLimits(); - временно отключено по лимитам
  },
  data() {
    return {
      isMenuCollapse: true,
      aboutModal: false
    };
  },
  computed: {
    ...mapGetters([
      "error",
      "config",
      "isUserSignin",
      "isBasePresent",
      "fullPageLoading",
      "serverVersion",
      "apiVersion",
      "limitRecords"
    ]),
    menuVerticalWidth: function() {
      return this.isMenuCollapse ? "64px" : "300px";
    }
  },
  watch: {
    error: function(message) {
      if (message) {
        let axiosError = false;
        if (typeof message === "object" && message.isAxiosError) {
          message = this.$t("common.errors.networkError");
          axiosError = true;
        } else {
          try {
            const errorMessages = message.split("~~");
            if (errorMessages[1] === "" && errorMessages[2] === "") {
              message = errorMessages[0];
            } else {
              const h = this.$createElement;
              message = h("details", null, [
                h(
                  "summary",
                  { style: "margin-bottom: 10px" },
                  errorMessages[0]
                ),
                h("span", { style: "color: grey" }, errorMessages[1]),
                h("span", { style: "color: grey" }, errorMessages[2])
              ]);
            }
          } catch {
            // console.log("Error", message);
          }
        }

        this.$alert(message, this.$t("common.errors.title"), {
          confirmButtonText: "OK",
          type: "error",
          callback: () => {
            this.$store.commit("setError", null);
            if (axiosError) {
              clearSession();
            }
          }
        });
      }
    }
    // limitRecords: function(limits) {                - временно отключено по лимитам
    //   if (!!limits.minRet && !!limits.maxRet && !!limits.defRet) {
    //     console.log("get limits", limits);

    //     const savedLimits = this.$localStorage.get("wb-limits");
    //     console.log("ls limits", savedLimits);

    //     // if (savedLimits) {
    //     //   const limit = JSON.parse(savedLimits);
    //     //   const language = limit.default;

    //     //   console.log("ls limits", savedLimits);
    //     // }
    //   }
    // }
  },
  methods: {
    ...mapActions(["getLimits"]),
    onMenuToggle() {
      this.isMenuCollapse = !this.isMenuCollapse;
    },
    onAbout() {
      this.aboutModal = true;
    }
  }
};
</script>

<style lang="scss">
@import "assets/ag-grid-catherine/ag-theme-new.scss";
@import "../node_modules/@ag-grid-community/all-modules/dist/styles/ag-grid.scss";
// @import "../node_modules/ag-grid-community/src/styles/ag-theme-balham/sass/ag-theme-balham.scss";
@import "../node_modules/@ag-grid-community/all-modules/dist/styles/ag-theme-balham/sass/legacy/ag-theme-balham-v22-compat.scss";

// @import "assets/ag-grid-catherine/table-borders.scss";
// @import "assets/theme-catherine/index.css";
// @import "assets/theme-catherine/element-ui-overwrite.css";
// переменные css для всего приложения
@import "assets/ag-grid-catherine/variables.scss";
@import "assets/ag-grid-catherine/_ag-theme-new-vars.scss";

@font-face {
  font-family: "Open Sans";
  //For Internet Explorer 9
  src: url("assets/ag-grid-catherine/OpenSansFont/opensans_regular/OpenSans-Regular-webfont.eot");

  src: url("assets/ag-grid-catherine/OpenSansFont/opensans_regular/OpenSans-Regular-webfont.eot?#iefix")
      format("embedded-opentype"),
    //all modern browsers
      url("assets/ag-grid-catherine/OpenSansFont/opensans_regular/OpenSans-Regular-webfont.woff")
      format("woff"),
    //Safari, Android, iOS
      url("assets/ag-grid-catherine/OpenSansFont/opensans_regular/OpenSans-Regular-webfont.ttf")
      format("truetype");
  //for legacy iOS SVG file is needed, but it's not supported anymore
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Open Sans Semibold";
  src: url("assets/ag-grid-catherine/OpenSansFont/opensans_semibold/OpenSans-Semibold-webfont.eot");

  src: url("assets/ag-grid-catherine/OpenSansFont/opensans_semibold/OpenSans-Semibold-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("assets/ag-grid-catherine/OpenSansFont/opensans_semibold/OpenSans-Semibold-webfont.woff")
      format("woff"),
    url("assets/ag-grid-catherine/OpenSansFont/opensans_semibold/OpenSans-Semibold-webfont.ttf")
      format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Open Sans Bold";
  src: url("assets/ag-grid-catherine/OpenSansFont/opensans_bold/OpenSans-Bold-webfont.eot");

  src: url("assets/ag-grid-catherine/OpenSansFont/opensans_bold/OpenSans-Bold-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("assets/ag-grid-catherine/OpenSansFont/opensans_bold/OpenSans-Bold-webfont.woff")
      format("woff"),
    url("assets/ag-grid-catherine/OpenSansFont/opensans_bold/OpenSans-Bold-webfont.ttf")
      format("truetype");
  font-weight: normal;
  font-style: normal;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  // display: flex;
  // flex-direction: column;
  // min-height: 100vh;
}

.header-container {
  position: sticky;
  top: 0px;
  height: 50px;
  line-height: 50px;
  padding-left: 1.5em;
  padding-right: 1.5em;
  background-color: #d8d8d8;
  // z-index: 2025;
  // overflow: hidden;
}

input[type="checkbox"] {
  width: 10px !important;
  height: 10px !important;
  margin-top: 9px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  outline: 1px solid #409eff;
  box-shadow: none;
  font-size: 2em;
}

input[type="checkbox"]:checked {
  background-color: #409eff;
}

input[type="checkbox"]:checked:after {
  content: "\2713";
  color: white;
  position: absolute;
  line-height: 1rem;
  font-size: 1rem;
  // padding-left: 0.15rem;
  margin-top: -2px;
  margin-left: -1px;
  transform: scale(0.8);
}

body {
  font-family: "Open Sans", sans-serif !important;
  margin: 0;
  padding: 0;
  background: #f2f2f2;
  background-size: contain;
}

// Стили для scrollbar
html,
body {
  scrollbar-width: thin !important;
  scrollbar-color: #5ea2c9 #f5f5f5 !important;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
  overflow-x: auto;
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #f5f5f5;
  overflow-x: auto;
}
::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
  background-color: #5ea2c9;
  overflow-x: auto;
}

.el-aside {
  background-color: #90b4ce;
}

.el-header {
  background-color: #d8d8d8;
  color: #606266;
}

// для того, чтобы названия элементов переносились правильно, а не по букве
.el-dialog__body div {
  word-break: break-word;
}

.el-button svg {
  margin-right: 5px;
}

.el-button.cancel-button {
  float: right;
  color: red;
  margin-left: 10px;
}

.el-checkbox {
  margin-left: 5px;
}

textarea.el-textarea__inner {
  color: #606266 !important;
}

.info-filter {
  border-radius: 4px;
  height: 24px;
  line-height: 24px;
  background-color: #ffffff;
  font-weight: bold;
  padding-top: 5px;
  padding-bottom: 4px;
  padding-left: 10px;
  width: 100%;
  margin-right: 15px;
}

.app-loading {
  position: absolute;
  margin: 0;
  padding: 0;
  top: 50%;
  margin-top: -11px;
  left: 50%;
  margin-left: -25px;
}

.ag-state-delivered {
  color: $dark-orange;
}

.ag-state-import-error {
  background-color: $error-background !important;
}

.ag-theme-balham .ag-row.ag-state-delivered {
  background-color: $light-yellow;
}

.ag-state-composing {
  color: $dark-sea-green;
}

.ag-theme-balham .ag-row.ag-state-composing {
  background-color: $light-green;
}

.ag-theme-balham .ag-row.ag-state-night-posting {
  background-color: $light-purple;
}

.ag-status-error {
  color: $error-color;
}

.ag-theme-balham .ag-row.ag-status-error {
  background-color: $error-bckgr;
}
.ag-theme-balham .ag-row.ag-row-selected {
  font-weight: 600;
}
.ag-header-group-cell::after {
  transform: scaleY(2.1);
  background-color: $ag-border-color;
}
.ag-grid-header::after {
  transform: scaleY(2.1);
  background-color: $ag-border-color;
}
.sum-column {
  text-align: right;
}
.name-column {
  text-align: left;
}
.editable-column {
  background-color: rgb(224, 251, 255);
}
.reporting-month {
  text-align: left;
  text-transform: capitalize;
}

.menu {
  z-index: 999;
}

.el-breadcrumb__inner a,
.el-breadcrumb__item .el-breadcrumb__inner.is-link {
  font-weight: 500;
  font-size: 1em;
  color: var(--main-headline-color);
}

.el-breadcrumb__inner a:hover,
.el-breadcrumb__item .el-breadcrumb__inner.is-link:hover {
  color: var(--off-background-color-dark);
}

.payment-sender {
  text-align: left;
}

.ag-theme-balham .ag-row-selected {
  border-color: var(--off-background-color);
}

/*--------------------------------------------*/
.ag-theme-balham .ag-header-cell-label {
  font-weight: 500;
  font-family: "Open Sans Semibold", sans-serif;
  letter-spacing: 0.05em;
  display: flex !important;
  justify-content: center;
  padding-left: 1.5em;
  padding-bottom: 0.1em;
}
.ag-theme-balham .ag-header-cell-label > span {
  /*Сам текст внутри*/
  float: none !important;
}
.ag-theme-balham .ag-header-group-cell-label {
  font-weight: 500;
  font-family: "Open Sans Semibold", sans-serif;
  letter-spacing: 0.05em;
  display: inline !important;
  padding-top: 0.6em;
}
.ag-theme-balham .ag-header-group-cell-label > span {
  float: none !important;
}
/*--------------------------------------------*/

.more-info__inner {
  height: 60vh;
  overflow-y: auto;
  scrollbar-color: grey lightgrey;
  scrollbar-width: thin;
}

.more-info__inner::-webkit-scrollbar {
  width: 3px;
}

.more-info__inner::-webkit-scrollbar-track {
  background-color: lightgrey;
}

.more-info__inner::-webkit-scrollbar-thumb {
  background-color: grey;
}

.key-name {
  font-weight: semibold;
  border: 1px solid rgb(231, 231, 231);
  padding: 1px 2px;
  border-radius: 10%;
  margin-right: 5px;
}

.about .el-dialog .el-dialog__body {
  padding: 5px 20px;
}
</style>

<style scoped>
.version-line {
  position: absolute;
  top: 1px;
  right: 20px;
  color: rgb(185, 185, 185);
}
.small {
  padding-left: var(--nav-left-width-short);
}
.full {
  padding-left: var(--nav-left-width);
}
.none {
  padding-left: 0px;
}

/* About */
.logo-container {
  height: 50px;
  line-height: 50px;
  background-image: url("./assets/logo.svg");
  background-repeat: no-repeat;
  background-position: top 7px left 0px;
}

.name {
  margin-left: 45px;
  font-size: 1.6em;
  font-weight: bold;
  color: #303133;
}

.description {
  margin-top: 5px;
  margin-bottom: 10px;
  font-size: 1.2em;
  font-weight: bold;
  color: #303133;
}
.version {
  margin: 3px 0;
  color: #303133;
}

.copyright {
  margin-top: 10px;
  font-weight: bold;
  color: #303133;
}
</style>
